import styled, { css } from 'styled-components';
import { remCalc, colors, media, layout } from '@prisjakt/ui-base';
import RatingComponent from '@prisjakt/ui-rating';
import { STAR_ICON_SIZE_MEDIUM } from '@prisjakt/ui-rating/src/constants';
import { VARIANTS } from '@prisjakt/ui-store-logo';
import ThumbUpIcon from 'mdi-react/ThumbUpIcon';
import HomeDeliveryComponent from '../home-delivery';

export { VARIANTS };

const SMILEY_RATING_MARGIN = 2;

export const StoreInfo = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-items: flex-start;
  margin: 0;
  padding: 0;

  ${media.smallOnly`
      padding: 0;
    `};
`;

export const StoreLogoAndRating = styled.div`
  display: flex;
  flex-direction: row;
  justify-items: flex-start;
  text-align: left;

  > * {
    margin-left: 0.5rem;
    &:first-child {
      margin-left: 0;
    }
  }

  ${media.largeUp`
    align-items: center;
  `}

  ${media.mediumDown`
    flex-direction: column;

    > * {
      margin-left: 0;
    }
  `};
`;

type RatingContainerProps = {
  showPriceListRatingExperiment: boolean;
};

const sharedAfterStyling = css`
  &::after {
    display: inline;
    content: attr(data-rating);
    font-size: ${remCalc(12)};
    line-height: 1.4;
    margin-left: 0.5em;
    color: ${p => p.theme.text.secondary};
  }
`;

export const RatingContainer = styled.div<RatingContainerProps>(
  props => css`
    display: flex;
    flex-direction: row;
    align-items: center;

    ${!props.showPriceListRatingExperiment &&
      css`
        ${sharedAfterStyling};
      `}
  `
);

export const RatingCount = styled.p(
  props => css`
    margin: 0 0 0 ${layout.spacing.xxSmall};
    font-size: ${layout.fontSizes.small.desktop.rem};
    color: ${props.theme.text.quaternary};
  `
);

type RatingWrapperProps = {
  showPriceListRatingExperiment: boolean;
};

export const RatingWrapper = styled.div<RatingWrapperProps>(
  props => css`
    /* Adds max-height to match price-row height the same as baseline */
    max-height: ${STAR_ICON_SIZE_MEDIUM}px;

    ${props.showPriceListRatingExperiment &&
      css`
        /* Adds max-height to match price-row height the same as baseline */
        max-height: ${STAR_ICON_SIZE_MEDIUM - SMILEY_RATING_MARGIN}px;
        margin-top: ${SMILEY_RATING_MARGIN}px;
      `}
  `
);

export const RecommendedRetailer = styled.div`
  font-size: ${remCalc(12)};
  white-space: nowrap;
  align-self: normal;
  margin-top: 0.3rem;
  color: ${props => props.theme.text.secondary};

  ${media.smallOnly`
    display: none;
  `};
`;

export const RecommendedRetailerIcon = styled(ThumbUpIcon).attrs({ size: 12 })`
  fill: ${colors.darkGray2};
  margin-right: 0.3rem;
`;

export const StoreInfoTitle = styled.span`
  /* Visually hidden since this text is primarily for Google */
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

export const CountryFlagWrapper = styled.div`
  display: flex;

  img {
    max-height: 11px;
  }
`;

type RatingProps = { showPriceListRatingExperiment: boolean };
export const Rating = styled(RatingComponent)<RatingProps>(
  props => css`
    ${props.showPriceListRatingExperiment &&
      css`
        display: none;
      `}
  `
);

export const HomeDelivery = styled(HomeDeliveryComponent)`
  padding-right: ${layout.spacing.xSmall};
`;
